module.exports = __webpack_public_path__ + "img/1.6bc14896.jpg";